module.exports = __webpack_public_path__ + "img/map.f33195d9.jpg";